<!--  -->
<template>
  <div class="re_box">
    <el-card class="box-card">
      <!-- 选择区 -->
      <div class="selectionArea">
        <div class="item">
          <el-input
            v-model="query.qr_code_link"
            style="width: 300px;"
            placeholder="请输入获客链接"
          />
        </div>
        <div class="item">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            @click="search"
          >搜索</el-button>
          <el-button
            size="mini"
            type="info"
            icon="el-icon-refresh"
            @click="reset"
          >重置</el-button>
          <el-button
            size="mini"
            type="success"
            icon="el-icon-s-help"
            @click="creater"
          >添加</el-button>
        </div>
      </div>
    </el-card>

    <el-card shadow="never">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        max-height="500"
      >
        <el-table-column
          prop="id"
          label="ID"
          width="100"
          align="center"
        />
        <el-table-column
          prop="qr_code_link"
          label="获客链接"
          align="center"
        />
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
        />
        <el-table-column
          label="员工名称"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              v-for="(item,index) in scope.row.corpUsers"
              :key="index"
              style="margin-left: 5px"
            >{{ item.name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="qr_code_link_id"
          label="qr_code_link_id"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="copyToClipboard(scope.row)"
            >复制监测链接</el-button>
            <el-button
              type="warning"
              size="mini"
              @click="copyToClipboard2(scope.row)"
            >复制获客链接</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <el-dialog
        :title="'新增监听链接'"
        :visible.sync="dialogVisible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="70%"
        :append-to-body="true"
      >
        <div>
          <el-form label-width="150px">
            <el-form-item label="请输入备注:">
              <el-input v-model="remake" />
            </el-form-item>
            <el-form-item label="获客链接:">
              <el-button @click="bindEmployee">绑定企微员工</el-button>
              <el-tag
                v-for="(item,index) in selectedRows"
                :key="index"
                style="margin-left: 5px"
              >
                {{ item.name }}({{ item.corp_name }})
              </el-tag>
            </el-form-item>
          </el-form>
        </div>
        <el-button
          type="info"
          @click="dialogVisible = false"
        >取消</el-button>
        <el-button
          type="success"
          @click="create"
        >确定</el-button>
        <el-dialog
          :title="'选择企微员工'"
          :visible.sync="employee_dialogVisible"
          :destroy-on-close="true"
          :close-on-click-modal="false"
          width="60%"
          :append-to-body="true"
        >
          <div>
            <div class="band_box">
              <div>
                <div class="serch_box">
                  <el-input
                    v-model="emp_query.keywords"
                    clearable
                    style="width:240px;margin-right:10px"
                    placeholder="请输入企微人员姓名/编号"
                  />
                  <el-button
                    type="primary"
                    class="search_icon"
                    icon="el-icon-search"
                    @click="empList"
                  />
                </div>
                <div class="choses_box">
                  <div
                    class="select_box"
                    :class="[fullName?'choose_blockr':'']"
                    @click="whole"
                  />
                  <div
                    v-if="fullName"
                    @click="whole"
                  >
                    取消全选
                  </div>
                  <div
                    v-else
                    @click="whole"
                  >
                    全选
                  </div>
                </div>
                <div class="choose_allblock">
                  <div
                    v-for="item,index in emp_list"
                    :key="index"
                    :class="[item.tips?'have ':'']"
                    class="choose_block"
                  >
                    <!-- {{ item.canChecked }} -->
                    <div
                      v-if="item.can_checked === 9"
                      class="select_boxone"
                    />
                    <div
                      v-else
                      class="select_box"
                      :class="[item.tips?'choose_blockr':'']"
                      @click="itenclick(item,index)"
                    />
                    <span>{{ item.name }}（{{ item.corp_name }}）</span>
                  </div>
                </div>

              </div>
              <div class="rigboxr">
                <div class="choiceofficialaccount">选中的企微人员</div>
                <el-tag
                  v-for="itemr,index in selectedRows"
                  :key="index"
                  style="margin-right:10px;margin-bottom:5px"
                  :closable="true"
                  @close="rightclick(itemr.employee_no,index)"
                >
                  {{ itemr.name }}
                </el-tag>
              </div>
            </div>
            <div class="que_box">
              <el-button
                type="primary"
                @click="quebtn"
              >确定</el-button>
            </div>

          </div>
          <pagination-right
            :total="emp_total"
            :page-sizes="[50]"
            :page="emp_query.page"
            @size-change="empFetchPageSize"
            @current-change="empFetchCurrentPage"
          />
        </el-dialog>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { employeeList, monitorLinkAdd, monitorLinkList } from '@/api/customer'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        qr_code_link: ''
      },
      tableData: [],
      total: null,
      dialogVisible: false,
      remake: '',
      employee_dialogVisible: false,
      emp_total: 0,
      emp_query: {
        page: 1,
        page_size: 50,
        keywords: null
      },
      emp_list: [],
      selectedRows: []
    }
  },
  computed: {
    // 判断是否选中了所有的行
    fullName: function() {
      return this.emp_list
        .filter(num => {
          return num.can_checked !== 9
        })
        .every(function(item) {
          return item.tips === true
        })
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    async list() {
      const data = await monitorLinkList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    search() {
      this.query.page = 1
      this.list()
    },
    reset() {
      this.query.page = 1
      this.query.name = ''
      this.query.status = ''
      this.query.created_at = ''
      this.list()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    empFetchPageSize(e) {
      this.emp_query.page_size = e
      this.empList()
    },

    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    empFetchCurrentPage(e) {
      this.emp_query.page = e
      this.empList()
    },
    creater() {
      this.dialogVisible = true
    },
    create() {
      if (this.remake && this.selectedRows) {
        monitorLinkAdd({
          remark: this.remake,
          corp_users: this.selectedRows
        }).then(res => {
          if (res.code === 0) {
            this.$message.success('新增成功')
            this.remake = ''
            this.selectedRows = []
            this.dialogVisible = false
          }
        })
      }
    },
    copyToClipboard(row) {
      const textToCopy = row.monitor_link
      if (navigator.clipboard) {
        navigator.clipboard.writeText(textToCopy)
      } else {
        const dummyInput = document.createElement('textarea')
        dummyInput.value = textToCopy
        dummyInput.style.left = '-9999px'
        dummyInput.style.top = '-9999px'
        dummyInput.style.textAlign = 'left'
        dummyInput.style.whiteSpace = 'pre-line'
        document.body.appendChild(dummyInput)
        dummyInput.select()
        document.execCommand('copy')
        document.body.removeChild(dummyInput)
      }
      this.$message.success('复制成功')
    },
    copyToClipboard2(row) {
      const textToCopy = row.qr_code_link
      if (navigator.clipboard) {
        navigator.clipboard.writeText(textToCopy)
      } else {
        const dummyInput = document.createElement('textarea')
        dummyInput.value = textToCopy
        dummyInput.style.left = '-9999px'
        dummyInput.style.top = '-9999px'
        dummyInput.style.textAlign = 'left'
        dummyInput.style.whiteSpace = 'pre-line'
        document.body.appendChild(dummyInput)
        dummyInput.select()
        document.execCommand('copy')
        document.body.removeChild(dummyInput)
      }
      this.$message.success('复制成功')
    },
    empList() {
      console.log(this.emp_query)
      employeeList(this.emp_query).then(res => {
        console.log(res)
        const data = res
        this.emp_total = res.data.total
        data.data.list.forEach(item => {
          item.tips = false
        })
        this.emp_list = data.data.list
        this.emp_list.forEach(item => {
          item.can_checked = 1
          this.selectedRows.forEach(items => {
            if (items.employee_no === item.employee_no) {
              item.tips = true
            }
          })
        })
      })
    },
    bindEmployee() {
      if (this.emp_list.length === 0) {
        this.empList()
      }
      this.employee_dialogVisible = true
    },
    whole() {
      if (this.fullName === true) {
        console.log('666')
        this.emp_list.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = false
            const index = this.selectedRows.findIndex(items => {
              return items.employee_no === item.employee_no
            })
            this.selectedRows.splice(index, 1)
          }
        })
      } else {
        console.log('777')
        this.emp_list.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = true
            this.selectedRows.map(re => re.employee_no).includes(item.employee_no) || this.selectedRows.push(item)
          }
        })
      }
    },
    itenclick(item, index) {
      item.tips = !item.tips
      if (item.tips) {
        this.selectedRows.push(item)
      } else {
        const index = this.selectedRows.findIndex(items => {
          return items.employee_no === item.employee_no
        })
        this.selectedRows.splice(index, 1)
      }
    },
    quebtn() {
      this.employee_dialogVisible = false
    },
    rightclick(employee_no, index) {
      this.selectedRows.splice(index, 1)
      this.emp_list.findIndex(items => {
        if (items.employee_no === employee_no) {
          items.tips = false
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.re_box {
  padding: 30px;
}

.selectionArea {
  display: flex;
}

.item {
  display: flex;
  align-items: center;
  /* flex-basis: calc(33.33% - 10px); */
  margin-right: 10px;
  margin-bottom: 10px;
}

.band_box {
  display: flex;
}
.serch_box {
  display: flex;
  margin-bottom: 10px;
}
.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.choose_blockr {
  background: #409eff;
}
.choose_block {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}
.choose_allblock {
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  overflow-x: scroll;
}
.have {
  color: #409eff;
}
.select_boxone {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}
.rigboxr {
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 450px;
  overflow-y: scroll;
  width: 350px;
  /* overflow: hidden;
  overflow-y: scroll; */
}
.choiceofficialaccount {
  margin-bottom: 10px;
}
.que_box {
  margin-top: 20px;
}
</style>
